/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useForm, Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Flatpickr from 'react-flatpickr';
import { Russian } from 'flatpickr/dist/l10n/ru';
import classNames from 'classnames';

import Button from 'components/base/Button';
import usersService from 'service/users';
import debitCreditSettlementPlanService from 'service/debitCreditSettlementPlanService';
import legalEntityCurrencyService from 'service/legalEntityCurrency';
import i18n from 'i18next';
import { useQuery } from 'react-query';

const getFlatpickrLocale = () => Russian;

const CreateDebitCreditSettlementPlan = ({
  setOpenOrderPlan,
  selectedOrderPlanId,
  refetch,
  setSelectedOrderPlanId
}: any) => {
  const { t } = useTranslation();

  type FormValues = {
    type: string;
    debitor_pid: number;
    charger_pid: number;
    currency_pid: number;
    amount: number | '';
    comment: string;
    photo: string;
    legal_entity_pid: string;
    status_pid: number | string;
    date_from: Date[];
    date_to: Date[];
  };

  const [chargers, setChargers] = useState<{ pid: number; name: string }[]>([]);
  const [debitors, setDebitors] = useState<{ pid: number; name: string }[]>([]);
  const [currencyOption, setCurrencyOption] = useState<any>([]);

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<FormValues>({
    mode: 'onChange',
    defaultValues: {
      type: 'PLANNED',
      debitor_pid: 0,
      charger_pid: 0,
      currency_pid: 0,
      amount: '',
      comment: '',
      photo: '',
      legal_entity_pid: '',
      status_pid: '',
      date_from: [],
      date_to: []
    }
  });

  // const statusCodes = [
  //   'CREATED_BY_SUPPLIER',
  //   'CREATED_BY_CHARGER',
  //   'SUBMITTED_BY_CHARGER',
  //   'CANCELLED_BY_CHARGER',
  //   'CONFIRMED_BY_RECIPIENT',
  //   'REJECTED_BY_RECIPIENT',
  //   'CONFIRMED_BY_SUPPLIER',
  //   'REJECTED_BY_SUPPLIER',
  //   'COMPLETED'
  // ];

  //GET Currency
  useQuery(['GET_CURRENCY'], async () => {
    await legalEntityCurrencyService
      .getList({ offset: 0, limit: 100 })
      .then((res: any) => {
        const options = res?.legal_entity_currencies?.map((option: any) => ({
          value: option.currency.pid,
          label: option.currency.name[i18n.language],
          currency_id: option.currency_id
        }));
        setCurrencyOption(options);
      });
  });

  useEffect(() => {
    debitCreditSettlementPlanService.getRecipientList({}).then((res: any) => {
      const plans = res?.legal_entities || [];
      if (!Array.isArray(plans)) {
        console.error('Ожидался массив планов, получено:', plans);
        return;
      }

      const debitorList = plans.map((plan: any) => ({
        pid: plan.pid,
        name: plan.name
      }));
      setDebitors(debitorList);
    });
  }, []);

  useEffect(() => {
    usersService
      .getList({})
      .then((res: any) => {
        const list = res?.data?.users || [];

        if (!Array.isArray(list)) {
          console.error('Ожидался массив пользователей, получено:', list);
          return;
        }

        const formatted = list.map((user: any) => ({
          pid: Number(user.id_number),
          name:
            `${user.first_name || ''} ${user.last_name || ''}`.trim() ||
            'No Name'
        }));

        setChargers(formatted);
      })
      .catch(error => {
        console.error('Ошибка загрузки пользователей:', error);
      });
  }, []);

  useEffect(() => {
    if (selectedOrderPlanId) {
      debitCreditSettlementPlanService
        .getByPid(selectedOrderPlanId)
        .then((res: any) => {
          const item = res;
          reset({
            type: item?.type || 'PLANNED',
            amount: item?.amount || 0,
            currency_pid: item?.currency_pid,
            debitor_pid: item?.debitor_pid || 0,
            charger_pid: item?.charger_pid || 0,
            comment: item?.comment || '',
            photo: item?.photo || '',
            legal_entity_pid: item?.legal_entity_pid?.toString() || '',
            status_pid: item?.status?.pid || '',
            date_from: item?.date_from ? [new Date(item.date_from)] : [],
            date_to: item?.date_to ? [new Date(item.date_to)] : []
          });
        });
    } else {
      reset({
        type: 'PLANNED',
        amount: '',
        currency_pid: 0,
        debitor_pid: 0,
        charger_pid: 0,
        comment: '',
        photo: '',
        legal_entity_pid: '',
        status_pid: '',
        date_from: [],
        date_to: []
      });
    }
  }, [selectedOrderPlanId, reset]);

  const onSubmit = (data: FormValues) => {
    const selectedCurrency = currencyOption.find(
      (option: any) => option.value === data.currency_pid
    );
    const payload = {
      ...data,
      amount: Number(data.amount),
      debitor_pid: Number(data.debitor_pid),
      charger_pid: Number(data.charger_pid),
      legal_entity_pid: data.legal_entity_pid
        ? Number(data.legal_entity_pid)
        : undefined,
      status_pid: selectedOrderPlanId ? Number(data.status_pid) : 0,
      date_from: data.date_from?.[0] ? data.date_from[0].getTime() : undefined,
      date_to: data.date_to?.[0] ? data.date_to[0].getTime() : undefined,
      currency_id: selectedCurrency?.currency_id,
      currency_pid: data.currency_pid
    };

    const action = selectedOrderPlanId
      ? debitCreditSettlementPlanService.update(selectedOrderPlanId, payload)
      : debitCreditSettlementPlanService.create(payload);

    action.then(() => {
      refetch();
      setOpenOrderPlan(false);
    });
    setSelectedOrderPlanId(0);
  };

  return (
    <Form
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <input type="hidden" value="PLANNED" {...register('type')} />

      {/* Debitor PID */}
      <Row className="mb-2">
        <Col>
          <Controller
            name="debitor_pid"
            control={control}
            rules={{
              validate: value =>
                value !== 0 || t('debitor_required_for_planned')
            }}
            render={({ field }) => (
              <Form.Floating>
                <Form.Select
                  {...field}
                  isInvalid={!!errors.debitor_pid}
                  value={field.value}
                  onChange={e => field.onChange(Number(e.target.value))}
                >
                  <option value={0} className="d-none"></option>
                  {debitors.map(debitor => (
                    <option key={debitor.pid} value={debitor.pid}>
                      {debitor.name}
                    </option>
                  ))}
                </Form.Select>
                <label>{t('debitor_pid')}</label>
                {errors.debitor_pid && (
                  <Form.Control.Feedback type="invalid">
                    {t('required_field')}
                  </Form.Control.Feedback>
                )}
              </Form.Floating>
            )}
          />
        </Col>
      </Row>

      {/* Charger PID */}
      <Row className="mb-2">
        <Col>
          <Controller
            name="charger_pid"
            control={control}
            rules={{
              validate: value =>
                value !== 0 || t('charger_required_for_planned')
            }}
            render={({ field }) => (
              <Form.Floating>
                <Form.Select
                  {...field}
                  value={field.value}
                  onChange={e => field.onChange(Number(e.target.value))}
                  isInvalid={!!errors.charger_pid}
                >
                  <option value={0} className="d-none">
                    {''}
                  </option>
                  {chargers.map(user => (
                    <option key={user.pid} value={user.pid}>
                      {user.name}
                    </option>
                  ))}
                </Form.Select>
                <label>{t('charger_pid')}</label>
                {errors.charger_pid && (
                  <Form.Control.Feedback type="invalid">
                    {t('required_field')}
                  </Form.Control.Feedback>
                )}
              </Form.Floating>
            )}
          />
        </Col>
      </Row>

      {/* Amount + Currency */}
      <Row className="mb-2">
        <Col md={8}>
          <Form.Floating>
            <Form.Control
              type="number"
              min={0.01}
              step={0.01}
              placeholder={t('amount')}
              defaultValue="" // чтобы поле было пустое
              {...register('amount', { required: true, min: 0.01 })}
              isInvalid={!!errors.amount}
            />
            <label>{t('amount')}</label>
            {errors.amount && (
              <Form.Control.Feedback type="invalid">
                {t('required_field')}
              </Form.Control.Feedback>
            )}
          </Form.Floating>
        </Col>

        <Col md={4}>
          <Controller
            name="currency_pid"
            control={control}
            rules={{
              validate: value => value !== 0 || t('required_field')
            }}
            render={({ field }) => (
              <Form.Floating>
                <Form.Select
                  {...field}
                  isInvalid={!!errors.currency_pid}
                  value={field.value}
                  onChange={e => field.onChange(Number(e.target.value))}
                >
                  <option value={0} className="d-none"></option>
                  {currencyOption.map((cur: any) => (
                    <option key={cur.value} value={cur.value}>
                      {cur.label}
                    </option>
                  ))}
                </Form.Select>
                <label>{t('currency')}</label>
                {errors.currency_pid && (
                  <Form.Control.Feedback type="invalid">
                    {errors.currency_pid.message}
                  </Form.Control.Feedback>
                )}
              </Form.Floating>
            )}
          />
        </Col>
      </Row>

      {/* Status */}
      {/* {selectedOrderPlanId !== 0 && (
        <Row className="mb-2">
          <Col>
            <Controller
              name="status_pid"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Floating>
                  <Form.Select {...field} isInvalid={!!errors.status_pid}>
                    <option className="d-none" value=""></option>
                    {statusCodes.map((code, idx) => (
                      <option key={idx + 1} value={idx + 1}>
                        {t(`${code}`)}
                      </option>
                    ))}
                  </Form.Select>
                  <label>{t('status')}</label>
                  {errors.status_pid && (
                    <Form.Control.Feedback type="invalid">
                      {t('status_required')}
                    </Form.Control.Feedback>
                  )}
                </Form.Floating>
              )}
            />
          </Col>
        </Row>
      )} */}

      {/* Date From */}
      <Row className="mb-2">
        <Col>
          <Controller
            name="date_from"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Form.Floating>
                <Flatpickr
                  {...field}
                  value={field.value ?? []}
                  onChange={dates => field.onChange(dates)}
                  className={classNames('form-control', {
                    'is-invalid': !!errors.date_from
                  })}
                  options={{
                    dateFormat: 'M j, Y',
                    minDate: 'today',
                    locale: getFlatpickrLocale(),
                    disableMobile: true
                  }}
                />
                <label>{t('date_from')}</label>
                {errors.date_from && (
                  <Form.Control.Feedback type="invalid">
                    {t('required_field')}
                  </Form.Control.Feedback>
                )}
              </Form.Floating>
            )}
          />
        </Col>
      </Row>

      {/* Date To */}
      <Row className="mb-2">
        <Col>
          <Controller
            name="date_to"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Form.Floating>
                <Flatpickr
                  {...field}
                  value={field.value ?? []}
                  onChange={dates => field.onChange(dates)}
                  className={classNames('form-control', {
                    'is-invalid': !!errors.date_to
                  })}
                  options={{
                    dateFormat: 'M j, Y',
                    minDate: 'today',
                    locale: getFlatpickrLocale(),
                    disableMobile: true
                  }}
                />
                <label>{t('date_to')}</label>
                {errors.date_to && (
                  <Form.Control.Feedback type="invalid">
                    {t('required_field')}
                  </Form.Control.Feedback>
                )}
              </Form.Floating>
            )}
          />
        </Col>
      </Row>

      {/* Submit Button */}
      <div className="d-flex justify-content-end mt-auto">
        <Button
          style={{ height: '48px', width: '100%' }}
          variant="primary"
          type="submit"
        >
          {t(selectedOrderPlanId ? 'save' : 'add')}
        </Button>
      </div>
    </Form>
  );
};

export default CreateDebitCreditSettlementPlan;
